import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  ModalButton
} from 'baseui/modal';

import debug from 'utils/debug';
import Timeline from './Timeline';

const { METHOD } = debug('c:ModalWindows:TimelineViewer');

export default (props) => {
  METHOD('TimelineViewer', props);

  const [isOpen, setIsOpen] = React.useState(false);
  const [config, setConfig] = React.useState();
  const [title, setTitle] = React.useState('Timeline');
  const [options, setOptions] = React.useState({});
  const [timelineState, setTimelineState] = React.useState();

  React.useEffect(() => {
    METHOD('Update', { props });

    window.openTimelineViewer = ($config, $opts) => {
      METHOD('openTimelineViewer', { $config, $opts });

      const opts = $opts || {};

      const $title = options.title || 'Timeline';

      setTitle($title);
      setConfig($config);
      setOptions(opts);
      setIsOpen(true);
    };

    window.closeTimelineViewer = () => {
      METHOD('closeTimelineViewer', { isOpen, config });
      setIsOpen(false);
    };

    return () => {
      METHOD('Cleanup', { isOpen, config });
      window.closeTableViewer = null;
    };
  });

  function onClose() {
    METHOD('onClose', { isOpen, config });

    setIsOpen(false);
  }

  const onTimelineState = (newTimelineState) => {
    METHOD('onTimelineState', { newTimelineState });

    // setTimelineState(newTimelineState);
    setTimelineState(null);
  };

  const onZoomOut = () => {
    METHOD('onZoomOut');

    if (timelineState) {
      const zoom = timelineState.get('config.chart.time.zoom');
      timelineState.update('config.chart.time.zoom', () => {
        return zoom < 22 ? zoom + 1 : zoom;
      });
    }
  };

  const onZoomIn = () => {
    METHOD('onZoomIn');

    if (timelineState) {
      const zoom = timelineState.get('config.chart.time.zoom');
      timelineState.update('config.chart.time.zoom', () => {
        return zoom > 10 ? zoom - 1 : zoom;
      });
    }
  };

  const useCalendarScroll = false;

  return (
    <React.Fragment>
      <Modal
        onClose={onClose}
        isOpen={isOpen}
        overrides={{
          Dialog: {
            style: {
              width: '90vw',
              height: useCalendarScroll ? '90vh' : undefined,
              display: 'flex',
              flexDirection: 'column'
            }
          }
        }}
      >
        <ModalHeader>{title}</ModalHeader>
        <ModalBody style={{ flex: '1 1 0' }}>
          <Timeline
            useCalendarScroll={useCalendarScroll}
            onTimelineState={onTimelineState}
            config={config}
          />
        </ModalBody>
        <ModalFooter>
          {timelineState && (
            <ModalButton onClick={onZoomOut}>Zoom Out</ModalButton>
          )}
          {timelineState && (
            <ModalButton onClick={onZoomIn}>Zoom In</ModalButton>
          )}
          <ModalButton onClick={onClose}>Close</ModalButton>
        </ModalFooter>
      </Modal>
    </React.Fragment>
  );
};
